const validateBMI = (totalHeight, bmi, weight) => {
    let isDeclined = false;
    let maxBMI = 40;
    if (totalHeight >= 75 && bmi < 16.95)
      isDeclined = true;
    else if (totalHeight < 75 && bmi < 17.05)
      isDeclined = true;
    else if (totalHeight < 58 || totalHeight > 80) // min and max height
      isDeclined = true;
    else if (weight < 82 || weight > 364) // min and max weight
      isDeclined = true;

    if (totalHeight === 66)
      maxBMI = 39.60;
    else if (totalHeight === 75)
      maxBMI = 39.90;
    else if (totalHeight === 76)
      maxBMI = 39.80;
    else
      maxBMI = 40;

    if (isDeclined || bmi > maxBMI)
      return true;

    return false;
}

export default validateBMI;